import ProtocoleLayout from "@/components/ProtocoleLayout";
import { PROTOCOLE_PUNAISES } from "@/data/protocoles";

const Protocole = () => (
    <ProtocoleLayout
        testid="protocole-page"
        tag="Procédure avant & après le traitement"
        title="Protocole"
        accent="punaises de lit"
        intro={PROTOCOLE_PUNAISES.intro}
        avant={PROTOCOLE_PUNAISES.avant}
        apresMethodes={PROTOCOLE_PUNAISES.apresMethodes}
        attention={PROTOCOLE_PUNAISES.attention}
        ctaTitle="Prêt pour l'intervention ?"
        ctaSubtitle="Logement préparé, traitement efficace : prenez rendez-vous dès maintenant. Intervention sous 2h, 7j/7."
        pdfUrl="/assets/protocole-punaises-de-lit.pdf"
        seoTitle="Protocole punaises de lit : avant & après traitement | Eradikbreizh"
        seoDescription="Préparation du logement avant traitement punaises de lit et consignes après : vapeur sèche 180°C 100% naturelle sans délai, ou traitement chimique avec précautions. Guide complet Eradikbreizh."
    />
);

export default Protocole;
